import { getViewCanSeeDeletedMessages } from 'find-and-filter-data/views-schema/public';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
export function useViewCanSeeDeletedMessages() {
  const currentView = useCurrentView();
  return getViewCanSeeDeletedMessages(currentView);
}